import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    defaultText: {
      maxWidth: "750px"
    },
    infoMessage: _objectSpread({}, theme.typography.infoMessage)
  };
});
var TextBlock = function TextBlock(_ref) {
  var containerClassName = _ref.containerClassName,
    bgColor = _ref.bgColor,
    variant = _ref.variant,
    title = _ref.title,
    titleAlign = _ref.titleAlign,
    titleVariant = _ref.titleVariant,
    subtitle = _ref.subtitle,
    subtitleAlign = _ref.subtitleAlign,
    subtitleVariant = _ref.subtitleVariant,
    text = _ref.text,
    textVariant = _ref.textVariant,
    textAlign = _ref.textAlign;
  var classes = useStyles();
  if (!variant || variant === "subtitleTitleText") {
    return /*#__PURE__*/React__default.createElement(Box, {
      className: clsx(classes.container, containerClassName),
      bgcolor: bgColor,
      maxWidth: 750,
      margin: "auto",
      mt: 10,
      px: 2
    }, subtitle && /*#__PURE__*/React__default.createElement(Box, {
      mt: 2
    }, /*#__PURE__*/React__default.createElement(Typography, {
      component: "div",
      className: clsx(_defineProperty({}, classes.infoMessage, !subtitleVariant)),
      align: subtitleAlign ? subtitleAlign : "center",
      variant: subtitleVariant ? subtitleVariant : "h3"
    }, subtitle)), title && /*#__PURE__*/React__default.createElement(Box, {
      mt: 2
    }, /*#__PURE__*/React__default.createElement(Typography, {
      align: titleAlign ? titleAlign : "center",
      variant: titleVariant ? titleVariant : "h1",
      component: "h2"
    }, title)), text && /*#__PURE__*/React__default.createElement(Box, {
      mt: 2
    }, /*#__PURE__*/React__default.createElement(Typography, {
      align: textAlign ? textAlign : "center",
      variant: textVariant ? textVariant : "body1"
    }, text)));
  }
  if (variant === "titleSubtitleText") {
    return /*#__PURE__*/React__default.createElement(Box, {
      className: containerClassName,
      bgcolor: bgColor,
      maxWidth: 750,
      margin: "auto",
      mt: 10
    }, title && /*#__PURE__*/React__default.createElement(Box, {
      mt: 2,
      maxWidth: 750
    }, /*#__PURE__*/React__default.createElement(Typography, {
      align: titleAlign ? titleAlign : "center",
      variant: titleVariant ? titleVariant : "h1"
    }, title)), subtitle && /*#__PURE__*/React__default.createElement(Box, {
      mt: 2,
      maxWidth: 750
    }, /*#__PURE__*/React__default.createElement(Typography, {
      component: "h2",
      className: !subtitleVariant ? classes.infoMessage : "",
      align: subtitleAlign ? subtitleAlign : "center",
      variant: subtitleVariant ? subtitleVariant : "h3"
    }, subtitle)), text && /*#__PURE__*/React__default.createElement(Box, {
      mt: 2,
      maxWidth: 750
    }, /*#__PURE__*/React__default.createElement(Typography, {
      align: textAlign ? textAlign : "center",
      variant: textVariant ? textVariant : "body1"
    }, text)));
  }
};
var types = {
  containerClassName: PropTypes__default.any,
  bgColor: PropTypes__default.string,
  variant: PropTypes__default.oneOf(["subtitleTitleText", "titleSubtitleText"]),
  title: PropTypes__default.string,
  titleAlign: PropTypes__default.oneOf(["center", "left", "right", "justify"]),
  titleVariant: PropTypes__default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "body1", "body2", "subtitle1", "subtitle2", "button", "caption", "overline", "infoMessage"]),
  subtitle: PropTypes__default.string,
  subtitleAlign: PropTypes__default.oneOf(["center", "left", "right", "justify"]),
  subtitleVariant: PropTypes__default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "body1", "body2", "subtitle1", "subtitle2", "button", "caption", "overline", "infoMessage"]),
  text: PropTypes__default.string,
  textAlign: PropTypes__default.oneOf(["center", "left", "right", "justify"]),
  textVariant: PropTypes__default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "body1", "body2", "subtitle1", "subtitle2", "button", "caption", "overline", "infoMessage"])
};
TextBlock.propTypes = types;

export { TextBlock as default, types };
//# sourceMappingURL=TextBlock.js.map
